/* global Raven */
import { createStore, applyMiddleware, compose } from "redux";
import createRavenMiddleware from "raven-for-redux";
import thunkMiddleware from "redux-thunk";
import { combineReducers } from "redux";
import throttle from "lodash/throttle";
import { loadState, saveState } from "./utils/localStorage";
import reducers from "./ducks/index";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const passthrough = () => next => action => {
  return next(action);
};

const middleware = composeEnhancers(
  applyMiddleware(
    thunkMiddleware,
    typeof Raven !== "undefined" ? createRavenMiddleware(Raven) : passthrough
  )
);

const store = createStore(combineReducers(reducers), loadState(), middleware);

store.subscribe(
  throttle(() => {
    saveState({
      auth: store.getState().auth
    });
  }, 1000)
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js